// src/components/WishlistHeaderButton.tsx
//
// Header heart linking to /wishlist, with a saved-count badge (mirrors
// CartButton's badge behavior).

import React from "react";
import { Link } from "react-router-dom";
import { useWishlist } from "../contexts/WishlistContext";

const WishlistHeaderButton: React.FC = () => {
  const { wishlist } = useWishlist();

  return (
    <Link
      to="/wishlist"
      aria-label="Wishlist"
      title="Wishlist"
      className="flex items-center justify-center gap-2 p-1.5 mb-1 transition duration-200"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-5 w-5"
      >
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
      {wishlist.length > 0 && (
        <span className="cart-badge">{wishlist.length}</span>
      )}
    </Link>
  );
};

export default WishlistHeaderButton;
